import React, { useState } from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import SlickSlider from "@/components/slick-slider";

import MediaWrapper from "@/components/mediaWrapper";
import LinkWrapper from "@/components/linkWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment HeroImageCarouselData on StrapiComponentHeroImageCarousel {
    titleLine1
    titleLine2
    titleLine3
    carouselItems {
      ...StrapiSharedLink
    }
    socialLinks {
      ...StrapiSharedLink
    }
  }
`;

function ImageCarousel({ data }) {
  if (!data) {
    return <></>;
  }
  const [carouselUrl, setCarouselUrl] = useState(
    data.carouselItems?.length && data.carouselItems[0]?.link?.url
  );

  return (
    <div className="bg-background-white">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:px-8">
        <div className="flex h-full flex-col justify-between">
          <div>
            <div className="mt-12 text-left uppercase text-text-primary sm:text-right">
              {data.titleLine1 && (
                <h1 className="text-5xl font-bold leading-tight xs:text-6xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl">
                  <MarkdownWrapper text={data.titleLine1} />
                </h1>
              )}
              {data.titleLine2 && (
                <MarkdownWrapper
                  text={data.titleLine2}
                  replaceParagraph={false}
                  className="text-4xl font-medium"
                />
              )}
              {data.titleLine3 && (
                <MarkdownWrapper
                  text={data.titleLine3}
                  replaceParagraph={false}
                  className="text-4xl font-medium"
                />
              )}
            </div>
          </div>
          {Boolean(data.socialLinks?.length) && (
            <ul className="z-20 hidden space-x-6 sm:flex">
              {data.socialLinks.map(
                (socialLink, index) =>
                  (socialLink.overwriteIcon || socialLink.link?.icon) && (
                    <li key={index}>
                      <LinkWrapper
                        to={socialLink.link?.url}
                        className="brightness-[1] hover:brightness-[.4]"
                      >
                        <MediaWrapper
                          media={
                            socialLink.overwriteIcon || socialLink.link.icon
                          }
                          objectFit="contain"
                          divClassName="m-2 w-5 h-5"
                        />
                      </LinkWrapper>
                    </li>
                  )
              )}
            </ul>
          )}
        </div>
        {Boolean(data.carouselItems?.length) && (
          <LinkWrapper to={carouselUrl}>
            <SlickSlider
              afterChange={(currentIndex) =>
                setCarouselUrl(data.carouselItems[currentIndex]?.link?.url)
              }
              lazyLoad="progressive"
              autoplay
              dots
              draggable={false}
              speed={1000}
              className="aspect-[1/1] w-full"
            >
              {data.carouselItems.map((image, index) => (
                <div key={index}>
                  <MediaWrapper
                    media={image.overwriteIcon || image.link.icon}
                    divClassName="aspect-[1/1] w-full rounded-sm"
                  />
                </div>
              ))}
            </SlickSlider>
          </LinkWrapper>
        )}
      </div>
    </div>
  );
}

ImageCarousel.propTypes = {
  data: PropTypes.object,
};

export default ImageCarousel;
